import React from 'react';
import Form from '../form/pre-order-form';

const NewsletterForm = () => <Form namespace="preorder" />;

export default NewsletterForm;
